import { Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { AccountingMovementsService } from '../movements/accounting-movements.service';
import { Utils } from '../../../shared/utils';

@Component({
  selector: 'convfact-accounting-export',
  templateUrl: './accounting-export.component.html',
  styleUrls: ['./accounting-export.component.css'],
  standalone: false,
})
export class AccountingExportComponent {

  monthFromExport = new UntypedFormControl(0);
  monthToExport = new UntypedFormControl(11);
  globalExport = new UntypedFormControl(false);

  isLoadingDiary = false;

  months = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

  constructor(
    private movementsService: AccountingMovementsService,
    public snackBar: MatSnackBar,
  ) {}

  exportDiary(): void {
    this.isLoadingDiary = true;
    this.movementsService.getExcelAccountMovements(
      this.monthFromExport.value + 1,
      this.monthToExport.value + 1,
      this.globalExport.value
    ).then(response => {
      FileSaver.saveAs(response, Utils.GetExcelName('Diario_contable'));
      this.isLoadingDiary = false;
    }).catch(() => {
      this.displayInfo('Ha ocurrido un error al exportar el diario contable');
      this.isLoadingDiary = false;
    });
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(message, '', options);
  }
  public trackByIndex(i: number) { return i; }

}
